import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { SystemSettingsSchema, SettingsUpdateSchema, ErrorResponseSchema } from './schemas';
const c = initContract();
export const settingsContract = c.router({
    get: {
        method: 'GET',
        path: '/settings',
        responses: {
            200: z.object({
                success: z.literal(true),
                data: SystemSettingsSchema,
            }),
            401: ErrorResponseSchema,
        },
        summary: 'Get system settings',
    },
    update: {
        method: 'PATCH',
        path: '/settings',
        body: SettingsUpdateSchema,
        responses: {
            200: z.object({
                success: z.literal(true),
                data: SystemSettingsSchema,
            }),
            400: ErrorResponseSchema,
            401: ErrorResponseSchema,
        },
        summary: 'Update system settings',
    },
});
//# sourceMappingURL=settings.js.map